import { Injectable } from '@angular/core';

import { Query } from '@datorama/akita';

import { User } from '@shared/user/models';
import { AuthUserStore } from './auth-user.store';

@Injectable({ providedIn: 'root' })
export class AuthUserQuery extends Query<User> {
  constructor(protected readonly store: AuthUserStore) {
    super(store);
  }
}
